import {DialogContent, DialogTitle, FormHelperText, Link, Stack} from '@mui/material'
import {Trans} from 'react-i18next'
import {useRef} from 'react'
import type {CredentialsSignInHandle} from './CredentialsSignIn'
import {CredentialSignInHelperActions, CredentialsSignIn, CredentialsSignInActions} from './CredentialsSignIn'
import {SignInContextProvider, useSignInContext} from './SignInContext'
import {MicrosoftSignInButton} from './MicrosoftSignInButton'
import {GoogleSignInButton} from './GoogleSignInButton'
import {SignUpConsent} from './SignUpPage'
import {GoSchool} from '@goschool/routing'

export function SignInPage() {
  return <SignInContextProvider mode="signIn">
    <SignInForm/>
  </SignInContextProvider>
}


function SignInForm() {
  const credRef = useRef<CredentialsSignInHandle>(null)

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    // read the ref at call time; it may be null on first render
    credRef.current?.submit(e)
  }

  return <form onSubmit={handleSubmit}>
    <DialogTitle><Trans i18nKey="auth:signIn.form.title"/></DialogTitle>

    <DialogContent>
      <Stack gap={1} flexGrow={1}>
        <Stack direction="row" justifyContent="flex-start" alignItems="center" gap={1}>
          <FormHelperText sx={{whiteSpace: 'nowrap'}}>
            <Trans i18nKey="auth:signIn.form.signInWithOther"/>
          </FormHelperText>
          <Stack direction="row">
            <GoogleSignInButton/>
            <MicrosoftSignInButton/>
          </Stack>

          <FormHelperText sx={{lineHeight: 1.2}}><SignUpConsent/></FormHelperText>
        </Stack>

        <CredentialsSignIn ref={credRef}/>
        <SignInError/>
        <CredentialSignInHelperActions/>
      </Stack>
    </DialogContent>
    <CredentialsSignInActions/>
  </form>
}

export function SignInError() {
  const {error} = useSignInContext()
  if (!error) {
    return null
  }
  return <FormHelperText error={true}>{error}</FormHelperText>
}

export function SignInConsent() {
  return <Trans i18nKey="auth:signIn.form.consent">
    <Link href={GoSchool.termsOfUse} target="_blank" rel="noopener noreferrer"/>
    <Link href={GoSchool.privacyStatement} target="_blank" rel="noopener noreferrer"/>
  </Trans>
}

